import { render, staticRenderFns } from "./BusinessEntryApplication.vue?vue&type=template&id=35e4c232"
import script from "./BusinessEntryApplication.vue?vue&type=script&lang=js"
export * from "./BusinessEntryApplication.vue?vue&type=script&lang=js"
import style0 from "./BusinessEntryApplication.vue?vue&type=style&index=0&id=35e4c232&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports